module.exports = __webpack_public_path__ + "img/Percent-Blue.e242ee5.webp";